import { Link } from '@inertiajs/react'
import type { ScoreboardStats, HighlightedMetric } from '../../types'
import { formatMetricValue as sharedFormatMetricValue } from '../scoreboard/formatters'

function formatMetricValue(value: number | null, format: string, unit: string | null, decimalPlaces: number | null | undefined): string {
  const formatted = sharedFormatMetricValue(value, format, decimalPlaces)
  if (formatted === '—') return formatted
  if (format !== 'currency' && format !== 'percentage' && unit) {
    return `${formatted} ${unit}`
  }
  return formatted
}

export default function ScoreboardSummaryCard({ stats, teamId }: { stats: ScoreboardStats; teamId: number }) {
  return (
    <div className="bg-white rounded-lg border border-stone">
      <div className="flex items-center justify-between px-5 py-4 border-b border-stone">
        <h3 className="text-base font-bold uppercase tracking-widest text-text-secondary">Scoreboard</h3>
        <Link href={`/teams/${teamId}/scoreboard`} className="text-sm font-semibold text-text-primary hover:underline">
          View Full Scoreboard →
        </Link>
      </div>

      <div className="p-5">
        {stats.highlighted_metrics.length > 0 ? (
          <div className="space-y-3">
            {stats.highlighted_metrics.map((m: HighlightedMetric) => (
              <div key={m.id} className="flex items-center gap-3">
                <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${m.on_track === true ? 'bg-[#15532E]' : m.on_track === false ? 'bg-[#ED1C24]' : 'bg-stone'}`} />
                <span className="text-base text-text-primary flex-1 truncate">{m.name}</span>
                <span className="text-base font-medium text-text-primary tabular-nums">
                  {formatMetricValue(m.current_value, m.format, m.unit, m.decimal_places)}
                </span>
                <span className="text-base text-text-muted tabular-nums">
                  / {formatMetricValue(m.target, m.format, m.unit, m.decimal_places)}
                </span>
                {m.owner && (
                  <div
                    className="w-6 h-6 rounded-full bg-charcoal/20 text-text-primary text-[12px] font-bold flex items-center justify-center flex-shrink-0"
                    title={`${m.owner.first_name} ${m.owner.last_name}`}
                  >
                    {m.owner.initials}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-base text-text-secondary text-center py-4">
            No metrics set up yet.{' '}
            <Link href={`/teams/${teamId}/scoreboard`} className="text-text-primary hover:underline">
              Add metrics
            </Link>
          </p>
        )}
      </div>
    </div>
  )
}
